var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNosubscriptiontransactions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 68,
    viewBox: "0 0 90 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 22.75H7.5M82.5 30.25L71.9737 18.4112C70.5665 16.8276 68.8397 15.56 66.907 14.6919C64.9744 13.8238 62.8799 13.375 60.7613 13.375H60M82.5 62.125H61.875L46.875 50.875C46.875 50.875 43.8375 48.8238 39.375 45.25C30 37.75 39.375 25.8775 48.75 32.125C56.385 37.2137 63.75 41.5 63.75 41.5",
    stroke: "#909090",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 39.625V15.25C60 13.2609 59.2098 11.3532 57.8033 9.9467C56.3968 8.54018 54.4891 7.75 52.5 7.75H15C13.0109 7.75 11.1032 8.54018 9.6967 9.9467C8.29018 11.3532 7.5 13.2609 7.5 15.25V37.75C7.5 39.7391 8.29018 41.6468 9.6967 43.0533C11.1032 44.4598 13.0109 45.25 15 45.25H39.375",
    stroke: "#909090",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNosubscriptiontransactions);
export default __webpack_public_path__ + "static/media/nosubscriptiontransactions.f932d1d46f568718d0b20c707f49de3b.svg";
export { ForwardRef as ReactComponent };